
import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { LocalizationState } from "@/store/modules/LocalizationModule";
import { mapState } from "vuex";
import { FOPLabelFormatData } from "@/models/NutritionLabels/FOPLabelFormatData";
import { SupportedPDS } from "@/models/NutritionLabels/SupportedPDS";
import NutritionLabelRepository from "@/utils/API/NutritionLabelRepository";
import { ExportLabelState } from "@/models/NutritionLabels/ExportLabelState";
import { CanadaFOPHighInMetadata } from "@/models/NutritionLabels/CanadaFOPHighInMetadata";
import { LabelTypeMetadata } from "@/models/NutritionLabels/LabelTypeMetadata";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vFrontOfPackageConfig extends Vue {
  @Model() model!: ExportLabelState;
  @Prop() recipeId!: number;
  @Prop() packageLabelType!: LabelTypeMetadata;
  @Prop() highIn!: CanadaFOPHighInMetadata;

  pdsSizeOptions: SupportedPDS[] = [];

  private localizationState!: LocalizationState;
  labelFormatOptions: FOPLabelFormatData[] = [];

  LabelTypeMetadata = LabelTypeMetadata;

  selectedFormat: FOPLabelFormatData = null;
  selectedPDS: SupportedPDS = null;

  get translations() {
    return this.localizationState.translations;
  }

  get hasCautionary(){
    return this.model.hasValidCautionary;
  }

  created() {
    this.loadLabelFormats();
  }

  loadLabelFormats() {
    if (this.model.nutritionCountry && this.model.nutritionCountry.name == "Canada") {
      NutritionLabelRepository.getFrontOfPackageOptions(this.model.nutritionLabel.labelLanguage).then((response) => {
        this.labelFormatOptions = response.data;
        let savedFormat = this.labelFormatOptions.find(
          (x: any) => x.formatValue == this.model.labelTypes[LabelTypeMetadata.FrontOfPack].fopFormat
        );

        this.updateFOPSelections(savedFormat || this.labelFormatOptions[0]);
      });
    }
  }

  updateFOPSelections(selectedFormat : FOPLabelFormatData){
    this.selectedFormat = selectedFormat;
    this.pdsSizeOptions = selectedFormat.supportedPDS;

    let selectedPDSFormat= this.pdsSizeOptions.find(
      (x: any) => x.value == this.model.labelTypes[LabelTypeMetadata.FrontOfPack].pdsSize
    );

    if(selectedPDSFormat){
      this.selectedPDS = selectedPDSFormat;
    }
    else{
      this.selectedPDS = this.pdsSizeOptions[0];
    }

    this.fetchFOPLabel();
  }

  foPFormatReducer(fopData: FOPLabelFormatData) {
    return fopData.formatValue;
  }

  foPPDSReducer(pdsData: SupportedPDS) {
    return pdsData.translationKey;
  }

  //Load FOP Label
  fetchFOPLabel(){
    const data = {
      recipeId: this.recipeId,
      labelFormatValue: this.selectedFormat.formatValue,
      pdsSizeValue: this.selectedPDS.value,
      labelType: this.packageLabelType,
      highInMetadata: this.highIn
    };
    this.model.loading = true;
    NutritionLabelRepository.previewFOPNutritionLabel(data)
      .then((response) => {
        this.model.loading = false;
        this.model.fopLabelPreview = response.data.content;
        this.model.fopNutritionLabelId = response.data.id;
        this.model.disableDownload = false;
      });
  }

  fetchLabelFormats(selectedFormat : FOPLabelFormatData) {
    const selected = this.labelFormatOptions.find(
      (format) => format.formatValue === selectedFormat.formatValue
    );

    if (selected) {
      this.selectedFormat = selected;
      this.model.labelTypes[LabelTypeMetadata.FrontOfPack].fopFormat = selected.formatValue;
      this.updatePDSSizes(selected.supportedPDS);
    }
  }

  updatePDSSizes(supportedPDS : SupportedPDS[]) {
    this.pdsSizeOptions = supportedPDS;

    this.selectedPDS = this.pdsSizeOptions[0];
    this.model.labelTypes[LabelTypeMetadata.FrontOfPack].pdsSize = this.selectedPDS.value;
    this.fetchFOPLabel();
  }

  fetchPreview() {
    this.model.labelTypes[LabelTypeMetadata.FrontOfPack].pdsSize = this.selectedPDS.value;
    this.fetchFOPLabel();
  }
}
